import donald from '../../images/team/donald.jpg'
import ephraim from '../../images/team/ephraim.jpg'
import fredrick from '../../images/team/fredrick.jpg'
import furaha from '../../images/team/furaha.jpg'
import mathayo from '../../images/team/mathayo.jpg'
import pamela from '../../images/team/pamela.jpg'

export const team = [
    {
        'names': 'Donald Manyambo',
        'image': donald,
        'position': 'Site Manager',
        'location': 'Ngaka Coal Mine',
        'hierarchy': 5,
        'description': 'Donald Manyambo graduated from Dar es salaam Institute of technology (DIT) in 2013 with a Diploma in Mining Engineering. He worked in several mining sites including Tulawaka Underground mine and Buzwagi Gold Mine. Tulawaka Gold Mine before being appointed as Site Manager of Ngaka Coal Mine from 2018 and now oversees all the Ngaka site operations on behalf of the company.'
    },
    {
        'names': 'Ephraim Kombe',
        'image': ephraim,
        'position': 'Operations Manager / Site Manager',
        'location': 'New Luika Gold Mine',
        'hierarchy': 3,
        'description': 'Ephraim graduated with a Bachelor of Science in Mining Engineering (Honours) degree from the University of Namibia. After which he worked for an Environmental consulting firm called MTL Consulting Company Ltd as a Mining Engineer from May 2016 to February 2019 where he was responsible for overseeing and participating in all mining related projects and becoming lead Mining Engineer in less than a year. He has been a part of 12 projects where he was lead Mining Engineer in 7 projects and coordinated 3 projects. Now he has been appointed as the Operations Manager for Ramani Investment Co Ltd and overseas all operations run by the company as of March 2019.'
    },
    {
        'names': 'Fredrick Temba',
        'image': fredrick,
        'position': 'Service Manager',
        'hierarchy': 4,
        'description': 'Fredrick Temba is a proffessional Electrician who acquired his Trade Test Certificate Grade One in Electronics in the year 2004. He worked with three compnies including ACACIA. He has experience with over 10 machines, and now he has joined the Ramani Investment Team as a Service Manager.'
    },
    {
        'names': 'Furaha Lema',
        'image': furaha,
        'position': 'Site Manager',
        'location': 'Stamigold Buharamulo Mine',
        'hierarchy': 5,
        'description': 'Donald Manyambo graduated from Dar es salaam Institute of technology (DIT) in 2013 with a Diploma in Mining Engineering. He worked in several mining sites including Tulawaka Underground mine and Buzwagi Gold Mine. Tulawaka Gold Mine before being appointed as Site Manager of Ngaka Coal Mine from 2018 and now oversees all the Ngaka site operations on behalf of the company.'
    },
    {
        'names': 'Dr. David Mathayo',
        'image': mathayo,
        'position': 'Executive Chairman',
        'hierarchy': 1,
        'description': 'Furaha Lema Elias is Tanzanian with over 10 years experience in the Mining Industry. He is a professional engineer registered with Tanzania Engineer\'s Registration Board (ERB). He started his career in mining as a Blaster through Graduate Mining Engineer, Mine Planning Engineer for both Underground and Open Pits, Senior Mine Planning Engineer to Site Manager. He joined RIL in March 2018 and has been very instrumental in supervision and ensuring that the desired equipment availability is achieved safely and in cost effective manner.'
    },
    {
        'names': 'Pamela Shoo',
        'image': pamela,
        'position': 'Managing Director',
        'hierarchy': 2,
        'description': 'Pamela Shoo is an ambitious and self-motivated woman who co-founded Ramani Investment Ltd. She worked with four companies prior co-founding Ramani Investment which are Stanbic Bank (T), Exim Bank (T), Collection Africa and Credit Reference Bureau Africa Ltd where she worked as a Managing Director. She is now the Managing Director of Ramani Investment Limited from 2005 to date.'
    },
]